__webpack_require__.p = "/apps/pricing-engine/";